var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconawesomeTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.423,
    height: 17.423,
    viewBox: "0 0 17.423 17.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#26093a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.712.563a8.712,8.712,0,1,0,8.712,8.712A8.71,8.71,0,0,0,8.712.563ZM12.99,6.531l-1.43,6.737c-.105.478-.39.594-.787.369L8.6,12.032l-1.05,1.012a.55.55,0,0,1-.439.214l.155-2.217L11.3,7.395c.176-.155-.039-.242-.27-.088l-4.988,3.14-2.15-.671c-.467-.148-.478-.467.1-.692l8.4-3.239c.39-.141.731.095.6.685Z",
    transform: "translate(0 -0.563)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeTelegram);
export default __webpack_public_path__ + "static/media/Icon awesome-telegram.8139be9aef68ecd949088d05504b95e1.svg";
export { ForwardRef as ReactComponent };